"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcMenuTabsVerticalBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var bc_menu_tabs_vertical_constants_1 = require("./bc-menu-tabs-vertical-constants");
var bc_menu_tabs_vertical_constants_2 = require("./bc-menu-tabs-vertical-constants");
var bc_menu_tabs_vertical_constants_3 = require("./bc-menu-tabs-vertical-constants");
var bc_menu_tabs_vertical_constants_4 = require("./bc-menu-tabs-vertical-constants");
var BcMenuTabsVerticalBehavior = (function (_super) {
    __extends(BcMenuTabsVerticalBehavior, _super);
    function BcMenuTabsVerticalBehavior() {
        var _this = _super.call(this) || this;
        _this._itemsElements = [];
        _this._items = [];
        _this._scrollListener = function () { return _this.setActiveItem(_this.changeActiveMenuItemWithScroll()); };
        return _this;
    }
    Object.defineProperty(BcMenuTabsVerticalBehavior.prototype, "items", {
        get: function () {
            return this._items;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BcMenuTabsVerticalBehavior.prototype, "activeItem", {
        get: function () {
            var _this = this;
            return this._items.find(function (item) {
                return item.itemText === _this._activeItem.textContent &&
                    item.itemTargetID === _this._activeItem.dataset.target;
            });
        },
        enumerable: false,
        configurable: true
    });
    BcMenuTabsVerticalBehavior.prototype._setUp = function () {
        this.loadMenuContainer();
        this.loadIndicator();
        this.loadMenuItems();
        this.loadAccessibility();
    };
    BcMenuTabsVerticalBehavior.prototype.loadMenuContainer = function () {
        var menuContainerElement = this.mySelf.querySelector(".".concat(bc_menu_tabs_vertical_constants_2.BC_MENU_TABS_VERTICAL_MENU));
        if (menuContainerElement) {
            this._menuContainer = menuContainerElement;
        }
        var bdsMenuContent = document.querySelector(".".concat(bc_menu_tabs_vertical_constants_4.BC_MENU_GLOBAL_CLASS, " .").concat(bc_menu_tabs_vertical_constants_4.BC_MENU_CONTENT_CLASS));
        if (bdsMenuContent) {
            bdsMenuContent.removeEventListener(common_constants_1.BcCommonConstants.EVENT_SCROLL, this._scrollListener);
            bdsMenuContent.addEventListener(common_constants_1.BcCommonConstants.EVENT_SCROLL, this._scrollListener);
        }
        else {
            document.removeEventListener(common_constants_1.BcCommonConstants.EVENT_SCROLL, this._scrollListener);
            document.addEventListener(common_constants_1.BcCommonConstants.EVENT_SCROLL, this._scrollListener);
        }
    };
    BcMenuTabsVerticalBehavior.prototype.loadIndicator = function () {
        var indicatorElement = this.mySelf.querySelector(".".concat(bc_menu_tabs_vertical_constants_1.BC_MENU_TABS_VERTICAL_INDICATOR));
        if (indicatorElement) {
            this._indicator = indicatorElement;
        }
    };
    BcMenuTabsVerticalBehavior.prototype.loadMenuItems = function () {
        var _this = this;
        var itemElements = this.mySelf.querySelectorAll(".".concat(bc_menu_tabs_vertical_constants_2.BC_MENU_TABS_VERTICAL_ITEM));
        itemElements.forEach(function (item, index) {
            if (index === 0) {
                _this.setActiveItem(item);
            }
            var itemTargetID = item.dataset[bc_menu_tabs_vertical_constants_2.BC_MENU_TABS_VERTICAL_ITEM_TARGET];
            var itemText = item.textContent;
            if (itemTargetID && itemText) {
                item.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () { var _a; return (_a = document.getElementById(itemTargetID)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: bc_menu_tabs_vertical_constants_4.BC_MENU_TABS_VERTICAL_SCROLL_ANIMATION }); });
                _this._items.push({ itemTargetID: itemTargetID, itemText: itemText });
            }
            _this._itemsElements.push(item);
        });
    };
    BcMenuTabsVerticalBehavior.prototype.setActiveItem = function (menuItem) {
        if (this._activeItem !== menuItem) {
            if (this._activeItem) {
                this._activeItem.classList.remove("".concat(bc_menu_tabs_vertical_constants_2.BC_MENU_TABS_VERTICAL_ITEM_ACTIVE));
            }
            menuItem.classList.add("".concat(bc_menu_tabs_vertical_constants_2.BC_MENU_TABS_VERTICAL_ITEM_ACTIVE));
            this.updateIndicatorStyle(menuItem);
            this._activeItem = menuItem;
        }
    };
    BcMenuTabsVerticalBehavior.prototype.updateIndicatorStyle = function (menuItem) {
        var itemHeight = menuItem.offsetHeight;
        var itemTop = menuItem.offsetTop - bc_menu_tabs_vertical_constants_1.BC_MENU_TABS_VERTICAL_CONTAINER_PADDING;
        if (this._indicator != null) {
            this._indicator.style.height = "".concat(itemHeight, "px");
            this._indicator.style.transform = "translateY(".concat(itemTop, "px)");
        }
    };
    BcMenuTabsVerticalBehavior.prototype.changeActiveMenuItemWithScroll = function () {
        var _this = this;
        var activeItem = this._activeItem;
        if (this.mySelf.parentElement && this.mySelf.parentElement.getBoundingClientRect().bottom === window.innerHeight) {
            activeItem = this._itemsElements[this._items.length - 1];
        }
        else {
            this._items.forEach(function (item, index) {
                var contentElement = document.getElementById(item.itemTargetID);
                if (contentElement) {
                    var elementTopPosition = contentElement.getBoundingClientRect().top;
                    var contentContainerTopPosition = _this._menuContainer.getBoundingClientRect().top;
                    if ((window.innerWidth < bc_menu_tabs_vertical_constants_3.TABLET_WIDTH && elementTopPosition <= 0) ||
                        elementTopPosition <= (contentContainerTopPosition + _this._menuContainer.clientHeight)) {
                        activeItem = _this._itemsElements[index];
                    }
                }
            });
        }
        return activeItem;
    };
    BcMenuTabsVerticalBehavior.prototype.loadAccessibility = function () {
        var _this = this;
        var title = this._menuContainer.querySelector("h5.".concat(bc_menu_tabs_vertical_constants_1.BC_MENU_TABS_VERTICAL_TITLE));
        if (title) {
            (0, helpers_1.addFocusable)(title, {
                tabindex: '0',
                label: bc_menu_tabs_vertical_constants_3.BC_MENU_TABS_VERTICAL_TITLE_LABEL,
                role: bc_menu_tabs_vertical_constants_3.BC_MENU_TABS_VERTICAL_MENU_ROLE,
            });
        }
        this._itemsElements.forEach(function (item, index) {
            (0, helpers_1.addFocusable)(item, {
                tabindex: '0',
                label: "".concat(item.textContent, ", item ").concat(index + 1, " de ").concat(_this._itemsElements.length, ", enlace."),
                role: bc_menu_tabs_vertical_constants_3.BC_MENU_TABS_VERTICAL_ITEM_ROLE,
            });
            item.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
                if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                    item.click();
                }
            });
        });
    };
    return BcMenuTabsVerticalBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcMenuTabsVerticalBehavior = BcMenuTabsVerticalBehavior;
